import { UserEmailTemplateForm } from 'src/app/services/dtos/userEmailTemplateForm';
import { UserForm } from '../../services/dtos/userForm';

export class FetchAllUsers {
  public static readonly type = '[CustomerUsers] Fetch All Users';
}

export class FetchAdminUsers {
  public static readonly type = '[CustomerUsers] Fetch Admin Users';
}

export class FetchAllRightsIfEmpty {
  public static readonly type = '[CustomerUsers] Fetch All Rights';
}

export class UpdateUser {
  public static readonly type = '[CustomerUsers] Update';
  public constructor(public payload: UserForm) { }
}

export class AddUser {
  public static readonly type = '[CustomerUsers] Add';
  public constructor(public payload: UserForm) { }
}

export class UpdateCustomerUser {
  public static readonly type = '[CustomerUsers] Update Customer User';
  public constructor(public payload: UserForm) { }
}

export class AddCustomerUser {
  public static readonly type = '[CustomerUsers] Add Customer User';
  public constructor(public customerId: string, public payload: UserForm) { }
}

export class DeleteCustomerUser {
  public static readonly type = '[CustomerUsers] Delete Customer User';
  public constructor(public customerId: string, public userId: string) { }
}

export class DeleteUser {
  public static readonly type = '[CustomerUsers] Delete';
  public constructor(public id: string) { }
}

export class AddUserEmailTemplate {
  public static readonly type = '[CustomerUsers] Add User Email Template';
  public constructor(public payload: UserEmailTemplateForm) { }
}

export class UpdateUserEmailTemplate {
  public static readonly type = '[CustomerUsers] Update User Email Template';
  public constructor(public payload: UserEmailTemplateForm) { }
}

export class DeleteUserEmailTemplate {
  public static readonly type = '[CustomerUsers] Delete User Email Template';
  public constructor(public emailTemplateId: string, public userId: string, public customerId?: string, ) { }
}

export class GetUserEmailTemplates {
  public static readonly type = '[CustomerUsers] Get User Email Template';
  public constructor(public userId: string, public customerId?: string) { }
}
